export default function getRegisteredFields(formName) {
    return (state) => {
        return state.form[formName].registeredFields
    }
}
